import React, {useState} from 'react';
import './ShoppingList.css';
import { formatIngredient } from '../utils/formatIngredient'; // <- nuevo import

const ShoppingList = ({ingredientes}) => {
    const [checked, setChecked] = useState(Array(ingredientes.length).fill(false));

    const handleCheck = (idx) => {
        setChecked(prev => prev.map((v, i) => i === idx ? !v : v));
   };

    return (
        <div className="shopping-list">
            <h4>Lista de la compra</h4>
            <ul className="shopping-list-list">
                {ingredientes.map((ing, idx) => (
                    <li key={idx} className="shopping-list-item">
                        <input
                            type="checkbox"
                            checked={checked[idx]}
                            onChange={() => handleCheck(idx)}
                            className="shopping-list-checkbox"
                        />
                        <span className={'shopping-list-ingredient' + (checked[idx] ? ' checked' : '')}>
                            {formatIngredient(ing)}
                        </span>
                    </li>
                ))}
            </ul>
        </div>
    );
};

export default ShoppingList;